enum InterviewScheduleError {
    DATE_IN_PAST,
    END_BEFORE_START,
    NO_DATES_SELECTED,
    NO_START_DATE,
    NO_INTERVIEW_TIME
}

export default InterviewScheduleError;